import React from 'react';
import { DatePicker } from '@/components/date/date-picker';
import { cn } from '@/lib/utils';
import { startOfDay, endOfDay, subDays, isSameDay } from 'date-fns';
export const FiltersRow = ({ from, to, setRange }) => {
    const today = React.useMemo(() => new Date(), []);
    const [preset, setPreset] = React.useState('7d');
    const yesterday = startOfDay(subDays(today, 1));
    const last7Start = startOfDay(subDays(today, 6));
    const last30Start = startOfDay(subDays(today, 29));
    const todayEnd = endOfDay(today);
    const applyPreset = React.useCallback((type) => {
        if (type === 'yesterday') {
            const start = yesterday;
            const end = endOfDay(yesterday);
            setRange(start, end);
        }
        if (type === '7d') {
            setRange(last7Start, todayEnd);
        }
        if (type === '30d') {
            setRange(last30Start, todayEnd);
        }
        setPreset(type);
    }, [setRange, yesterday, last7Start, last30Start, todayEnd]);
    React.useEffect(() => {
        if (isSameDay(from, yesterday) && isSameDay(to, endOfDay(yesterday))) {
            setPreset('yesterday');
            return;
        }
        if (isSameDay(from, last7Start) && isSameDay(to, todayEnd)) {
            setPreset('7d');
            return;
        }
        if (isSameDay(from, last30Start) && isSameDay(to, todayEnd)) {
            setPreset('30d');
            return;
        }
        setPreset('custom');
    }, [from, to, yesterday, last7Start, last30Start, todayEnd]);
    return (<div className="border-b border-border/50 pb-4">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                <div>
                    <p className="text-xs uppercase tracking-widest text-muted-foreground">Workspace Scope</p>
                </div>

                <div className="flex flex-wrap items-center gap-6">
                    <div className="flex items-center gap-2 text-xs">
                        {[
            { label: 'Yesterday', value: 'yesterday' },
            { label: 'Last 7 Days', value: '7d' },
            { label: 'Last 30 Days', value: '30d' },
        ].map((item) => (<button key={item.value} onClick={() => applyPreset(item.value)} className={cn('px-3 py-1.5 rounded-md transition-colors', preset === item.value
                ? 'bg-muted text-foreground'
                : 'text-muted-foreground hover:text-foreground')}>
                                {item.label}
                            </button>))}
                    </div>

                    <div className="hidden lg:block h-6 w-px bg-border/40"/>

                    <div className="flex items-center gap-3">
                        <DatePicker value={from} onChange={(date) => {
            if (!date)
                return;
            setRange(startOfDay(date), to);
        }}/>

                        <span className="text-xs text-muted-foreground">→</span>

                        <DatePicker value={to} onChange={(date) => {
            if (!date)
                return;
            setRange(from, endOfDay(date));
        }}/>
                    </div>
                </div>
            </div>
        </div>);
};
FiltersRow.displayName = 'FiltersRow';
